// extracted by mini-css-extract-plugin
export var backGround = "ParallaxBackground-module--backGround--A65lH";
export var circle = "ParallaxBackground-module--circle--y6a+l";
export var lineLink = "ParallaxBackground-module--line-link--2BoN3";
export var lineLink_black = "ParallaxBackground-module--line-link_black--fmvXm";
export var lineLink_grey = "ParallaxBackground-module--line-link_grey--RHueK";
export var lineLink_primary = "ParallaxBackground-module--line-link_primary--9Hv5A";
export var lineLink_secondary = "ParallaxBackground-module--line-link_secondary--cY6cO";
export var lineLink_white = "ParallaxBackground-module--line-link_white--6CI5-";
export var logoAnimation = "ParallaxBackground-module--logoAnimation--fJNfC";
export var logoCircles = "ParallaxBackground-module--logoCircles--M5-Zw";
export var logoCirclesCont = "ParallaxBackground-module--logoCirclesCont--J9hkV";
export var logoCirclesCr = "ParallaxBackground-module--logoCirclesCr--tssN9";
export var wave = "ParallaxBackground-module--wave--kLByW";
export var waveCircle = "ParallaxBackground-module--waveCircle--0jy2U";
export var waveCont = "ParallaxBackground-module--waveCont--R0Y5u";
export var waveRow = "ParallaxBackground-module--waveRow--CBQ0s";